import { Box, Button } from "@chakra-ui/react"
import React, { ReactNode } from "react"
import { useIsMobileDevice } from "src/util/browser"

type Props = {
  onClick?: () => void
  color?: string
  logo: ReactNode
  title: string
}

export const MenuIconBtn: React.FC<Props> = ({
  onClick,
  color,
  logo,
  title
}) => {
  const isMobile = useIsMobileDevice()
  return (
    <Button
      bg="transparent"
      p="0"
      _hover={{
        background: "rgba(255, 255, 255, 0.1)"
      }}
      _active={{}}
      _focus={{}}
      borderRadius={0}
      padding=".5rem 1.5rem .5rem .75rem"
      fontFamily="Roboto"
      fontSize="14px"
      fontWeight="normal"
      color={color ?? "white"}
      display="flex"
      flexDir="row"
      alignItems="center"
      justifyContent="flex-start"
      width="100%"
      type="button"
      onClick={isMobile ? null : onClick}
      onTouchStart={isMobile ? onClick : null}
    >
      <Box mr=".5rem">{logo}</Box>
      {title}
    </Button>
  )
}
